// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1rxGA","layout":"styles_layout__22cO2","arrow_button":"styles_arrow_button__3T-lJ","wrapper":"styles_wrapper__30Cgi"};